import React from 'react';
import WS from '../utils/websocket';
import Api from '../utils/api';

export default class extends React.Component{
    WS = WS;
    Api = Api
}